import React from "react";

const Reimbursement = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M17.36 3.82V2.709c0-.577.649-.907 1.076-.577l3.144 2.06c.4.276.4.88 0 1.182l-3.103 2.089a.693.693 0 0 1-1.075-.577v-1.03c-6.37.425-11.444 5.729-11.444 12.186a.981.981 0 0 1-.979.976A.964.964 0 0 1 4 18.04c-.027-7.57 5.915-13.78 13.36-14.22ZM14.824 30.654l3.116-2.088a.693.693 0 0 1 1.075.577v1.044c6.356-.44 11.43-5.73 11.43-12.2a.98.98 0 0 1 .98-.976c.537 0 1.02.467 1.02 1.017 0 7.542-5.916 13.711-13.389 14.151v1.113c0 .577-.648.907-1.075.577l-3.144-2.02c-.427-.316-.427-.934-.013-1.195Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M18.202 8.946c-5.033 0-9.1 4.04-9.1 9.068 0 5.015 4.067 9.068 9.1 9.068 5.046 0 9.1-4.053 9.1-9.068 0-5.029-4.054-9.068-9.1-9.068Zm1.365 14.289-1.462-2.597c-.069-.151-.138-.261-.22-.33a.756.756 0 0 0-.607-.247h-1.379v-1.21h1.875c.4 0 .703-.095.91-.288.18-.178.303-.426.386-.714H15.9v-.99h3.13c-.055-.247-.166-.453-.331-.59-.193-.179-.496-.275-.883-.275H15.9v-1.003h5.488v1.003h-1.31c.11.11.22.206.29.357.068.151.096.33.123.509h.897v.989h-.841c-.042.357-.11.7-.262.975a2.09 2.09 0 0 1-.828.866 3.125 3.125 0 0 1-.537.206c.165.027.317.082.455.165.22.123.427.357.606.7l1.434 2.474h-1.847Z"
            fill={fill}
        />
    </svg>
);

export default Reimbursement;
